export type MenuAction =
	| { type: 'navigation'; url: string }
	| { type: 'operation'; actionName: string };

export interface MenuItem {
	icon: string;
	label: string;
	action: MenuAction;
	showOnlyOn?: 'web' | 'desktop';
}

export const MAIN_MENU_ITEMS: MenuItem[] = [
	{
		icon: 'assets/img/menu/home.webp',
		label: 'Home',
		action: {
			type: 'navigation',
			url: '/lobby/home',
		}
	},
	{
		icon: 'assets/img/menu/shop.webp',
		label: 'Shop',
		action: {
			type: 'navigation',
			url: '/shop-home',
		},
		showOnlyOn: 'desktop',
	},
	{
		icon: 'assets/img/menu/profile.webp',
		label: 'Profile',
		action: {
			type: 'navigation',
			url: '/lobby/profile',
		}
	},
	{
		icon: 'assets/img/menu/cashier.webp',
		label: 'Cashier',
		action: {
			type: 'navigation',
			url: '/lobby/cashier',
		},
		showOnlyOn: 'desktop',
	},
	{
		icon: 'assets/img/menu/picks.webp',
		label: 'Picks',
		action: {
			type: 'navigation',
			url: '/social',
		}
	},
	{
		icon: 'assets/img/menu/rewards.webp',
		label: 'Rewards',
		action: {
			type: 'navigation',
			url: '/rewards',
		},
		showOnlyOn: 'desktop',
	},
	{
		icon: 'assets/img/menu/points.webp',
		label: 'Points & Eligibility',
		action: {
			type: 'navigation',
			url: '/points',
		},
		showOnlyOn: 'desktop',
	},
	// {
	// 	icon: 'assets/img/menu/crypto.webp',
	// 	label: 'Crypto Wallets',
	// 	action: {
	// 		type: 'navigation',
	// 		url: '',
	// 	}
	// },
	{
		icon: 'assets/img/menu/options.webp',
		label: 'Options & Info',
		action: {
			type: 'navigation',
			url: '/lobby/options',
		}
	},
];

export const BOTTOM_MENU_ITEMS: MenuItem[] = [
	{
		icon: 'assets/img/menu/support.webp',
		label: 'Support', action: {
			type: 'operation',
			actionName: 'support',
		}
	},
	{
		icon: 'assets/img/menu/logout.webp',
		label: 'Log Out',
		action: {
			type: 'operation',
			actionName: 'logout'
		}
	},
];
